import { fg } from '@confluence/feature-gating';

export const isEmojiTitleEnabled = (contentType: string | null | undefined): boolean => {
	// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
	return contentType === 'whiteboard' && fg('confluence_frontend_whiteboard_emoji_titles');
};
